import type {
  UpdateWeddingRequest,
  WWeddingView,
  WWeddingAccountView,
} from '@zola/svc-web-api-ts-client';

export type WeddingType = UpdateWeddingRequest & WWeddingView;
export interface WeddingState {
  wedding: WeddingType;
  account: WWeddingAccountView;
}
export interface RootState {
  wedding: WeddingState;
}

export const getWedding = (state: RootState): WWeddingView => state.wedding.wedding || {};

export const getWeddingAccountHash = (state: RootState): string | undefined =>
  state.wedding.account.hash_id;

export default getWedding;



// WEBPACK FOOTER //
// ./src/selectors/wedding/index.ts